export enum ApiRateType
{
   Daily,
   Weekly,
   Monthly
}

export enum ApiRequestAction
{
   New,
   Update,
   Delete
}

export enum RoundingType {
   RoundOff = 'RoundOff',
   RoundUp = 'RoundUp',
   RoundDown = 'RoundDown',
   Truncate = 'Truncate',
 }

 export enum NotifyMsgType {
   Success,
   Error,
   Info,
 }